import React from 'react'
import { Navigate } from 'react-router-dom';
import authService from '../../services/authService';
import { useAuthContext } from '../../contexts/AuthContext';
import { Radio, Form, Input, message } from 'antd'
import  backgroundImage from "../../assets/login-pg-icons/Group 289307.png"
import AccentureSong from "../../assets/logo2.png"

const Login = () => {

  const { isAuthenticated, setIsAuthenticated } = useAuthContext()
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const handleLogin = (values) => {
    const { email, password, role } = values

    if(role === 'admin') {
      authService.adminLogin({ email, password, role })
        .then(() => setIsAuthenticated(true))
        .catch((error) => {
          // form.resetFields()
          messageApi.error(error)
        })
    }
    else if(role === 'consultant') {
      authService.consultantLogin({ email, password, role })
        .then(() => setIsAuthenticated(true))
        .catch((error) => {
          // form.resetFields()
          messageApi.error(error)
        })
    }
  }

  const logostyle = {
    // backgroundImage: url('../../assets/login-pg/Group 289307.svg')
    backgroundColor:'#18A07A'
  }

  return (isAuthenticated ?
    <Navigate to={'/'}/> :
    <>
      {contextHolder}
      <div className="w-full flex h-screen" style={{backgroundColor:"#EBF6FF", minWidth: 1850}}>
        <div className="flex w-[800px] h-full flex-col justify-center items-center mx-auto lg:px-8">
        <img style={{height:'100px', display:'flex', justifyContent:'center', alignItems:'center', position:'absolute' ,top:'48px'}} src={AccentureSong} alt="" />
          <div className="box" style={{
            padding: '40px',
             borderRadius: '20px', background: 'white', width:'60%'}}>
          <div style={{display:'flex', flexDirection:'column', gap:'8px'}}>
              <p style={{
                // fontFamily:'Lato', 
                fontSize:'25px', display:'flex' ,margin:'0px',fontFamily:"LatoBold", fontSize:'25px', color:'#07224D' }}>Login</p>
              <p style={{
                // fontFamily:'Lato', 
                fontSize:'16px', display:'flex', color:'#8A8A95', marginTop:'0px'}}>Please enter your login information</p>
          </div>
          <div 
          // className=" sm:mx-auto sm:w-full sm:max-w-sm"
          >
            <Form className="space-y-6"
              // labelCol={{ span: 6 }}
              // wrapperCol={{ span: 14 }}
              name='login-form'
              form={form}
              requiredMark={false}
              layout="horizontal"
              size='large'
              onFinish={handleLogin}
              initialValues={{role: 'admin'}}
            >
              <Form.Item
                labelCol={{ span: 24 }}
                // label="Email"
                label={<label style={{ color:'#07224D', fontSize:'18px', fontFamily:'LatoRegular', marginBottom:'13px' }}>Email</label>}
                name="email"
                // style={{color:'#07224D', fontSize:'18px', fontWeight:'400', backgroundColor:'red'}}
                rules={[{ required: true, message: 'Please input your email' }]}
              >
                <input type='email' placeholder='Email' style={{padding:'18px 16px 18px 16px', border:'1px solid #92A7BE', borderRadius:'10px', color:'#92A7BE', fontSize:'16px', fontWeight:'400', width:'93%' }}/>
              </Form.Item>
              <Form.Item
                labelCol={{ span: 24 }}
                // label="Password"
                label={<label style={{ color:'#07224D', fontSize:'18px', fontWeight:'400', marginBottom:'13px' }}>Password</label>}
                name="password"
                rules={[{ required: true, message: 'Please input your password' }]}
              >
                <input type='password' minLength={8} style={{padding:'18px 16px 18px 16px', border:'1px solid #92A7BE', borderRadius:'10px', color:'#92A7BE', fontSize:'16px', fontWeight:'400', width:'93%' }} placeholder='Password'/>
              </Form.Item>
              <Form.Item
                label="Login as:"
                name="role"
                rules={[{ required: true, message: "Please select an option" }]}
              >
                <Radio.Group>
                  <Radio style={{fontSize:'16px', fontWeight:'700', color:'#07224D' }} value={'admin'}>Admin</Radio>
                  <Radio style={{fontSize:'16px', fontWeight:'700', color:'#07224D' }} value={'consultant'}>Consultant</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item>
                <button
                  type="submit"
                  style={{border:'none' , padding:'20px 86.5px 20px 86.5px', backgroundColor:'#3BA4FE', color:'#FFFFFF', fontSize:'18px',fontWeight:'700', display:'flex', justifyContent:'center', alignItems:'center', width:'100%', borderRadius:'10px' }}
                  //  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
                  // className="flex w-full justify-center rounded-md bg-[#3BA4FE] px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-[#3BA4FE] focus-visible:outline-[#3BA4FE]"
                >
                  Login
                </button>
              </Form.Item>
            </Form>
          </div>
          </div>
        </div>
        <div className=" lg:flex  hidden" style={{backgroundColor:'#3BA4FE', width:"47%", display:"flex", alignItems:"center", margin:"28px", borderRadius:"20px", justifyContent:"center"}}>
          {/* <img className="background" src={Logo} alt="logo" /> */}
          <div style={{
            height: "531px",
            width: "626px",
            backgroundImage: `url('${backgroundImage}')`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            color:'#FFFFFF',
            // fontFamily: 'Lato',
            fontWeight: '700'
    }}>
          <p style={{lineHeight:"36px", fontSize: '30px', margin:'0px' }}>Welcome To Gen AI Compliance</p>
          <p style={{lineHeight:"29px", fontSize: '24px', margin:'0px' }}>Please Login to your account</p>
          </div>
        </div>
      </div>
    </>
  )
}

export default Login